// extracted by mini-css-extract-plugin
module.exports = {"builderContent":"SingleBrandPage_builderContent__IUYdC"};